import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPriceTag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.137 2.25432C15.738 2.13411 16.3577 2.29656 16.8211 2.68868L16.9434 2.80127L30 15.8579C30.3751 16.2329 30.5858 16.7417 30.5858 17.2721C30.5858 17.7436 30.4193 18.1979 30.1189 18.5565L30 18.6863L18.6863 30C18.3112 30.3751 17.8025 30.5858 17.2721 30.5858C16.8006 30.5858 16.3463 30.4193 15.9877 30.1189L15.8579 30L2.80127 16.9434C2.36783 16.51 2.15925 15.9042 2.22851 15.3012L2.25432 15.137L4.27069 5.05515C4.34194 4.69888 4.59971 4.41261 4.93913 4.3012L5.05515 4.27069L15.137 2.25432ZM15.5292 4.21549L6.10001 6.10001L4.21549 15.5292L17.2721 28.5858L28.5858 17.2721L15.5292 4.21549ZM12 10.5C12 9.67158 11.3284 9.00001 10.5 9.00001C9.67158 9.00001 9.00001 9.67158 9.00001 10.5C9.00001 11.3284 9.67158 12 10.5 12C11.3284 12 12 11.3284 12 10.5Z"
	})
});
export default SvgPriceTag;
